angular.module('dnecom')
    .controller('IntegrationsController', ["$scope", "wizardModal", "$http", "notifications", "$location", function($scope, wizardModal, $http, notifications, $location) {
        const RESTRICT_DUBLICATE = ['other', 'shipping'];
        $scope.GRAccountsLoading = false;
        $scope.PAccountsLoading = false;

        $scope.dtAccountsTableInstance = {};
        $scope.dtInstanceCallback = function(dtInstance)
        {
            $scope.dtAccountsTableInstance = dtInstance;
        };
        $scope.dtAccountsColumnDefs = [{
            targets: 2,
            orderable: false,
            width: '150px'
        }, {
            targets: 1,
            width: '250px',
            searchable: false
        }];

        $scope.accounts = TemplateData.value('accounts');
        $scope.accountTypeGroup = TemplateData.value('typeGroup');

        $scope.settings = TemplateData.value('xomatorSettings');
        $scope.settings.defaultPriceMarkup = parseInt($scope.settings.defaultPriceMarkup);
        $scope.paystackCurrencies = [
            {code: 'GHS', name: 'Ghanaian Cedi (GHS)'},
            {code: 'NGN', name: 'Nigerian Naira (NGN)'},
            {code: 'USD', name: 'United States Dollar (USD)'},
            {code: 'ZAR', name: 'South African Rand (ZAR)'},
        ];

        $scope.getZapierAccount = function () {
            return $scope.accounts.find(function (item) {
                return item.type == 'zapier' && item.name == 'active';
            })
        }

        $scope.getZapierDisactivatedAccount = function () {
            return $scope.accounts.find(function (item) {
                return item.type == 'zapier';
            })
        }

        $scope.zapierEnabled = $scope.getZapierAccount() ? true : false;
        $scope.zapierRequest = false;

        $scope.canAddAccount = function () {
          if (
              RESTRICT_DUBLICATE.includes($scope.accountTypeGroup)
              && (
                  $scope.accounts.find(function (account) { return account.type === 'aftership';})
                  || $scope.accounts.find(function (account) { return account.type === 'mcafee';})
              )
          ) {
              return false;
          }
          if ($scope.accountTypeGroup == 'pro-connector') {
              return false;
          }

          return true;
        };
        $scope.addAccount = function($event) {
            if ($event) {
                $event.preventDefault();
            }

            var account = {
                'id': 0,
                'name': '',
                'type': '',
                'properties': {},
                'typeGroup': $scope.accountTypeGroup
            };

            var newAccountModal = wizardModal.open({
                'templateUrl': 'newAccountModal.html',
                'controller': 'IntegrationsModalController',
                'size': null,
                'resolve': {
                    'account': function() {
                        return account;
                    },
                    'settings': function() {
                        return $scope.settings;
                    },
                    'paystackCurrencies': function() {
                        return $scope.paystackCurrencies;
                    },
                }
            });

            newAccountModal.result.then(function(account) {
                $scope.editAccount(account);
            });
        };

        $scope.editAccount = function(account) {
            var templateUrls = {
                'aweber': 'aweberModal.html',
                'getresponse': 'getResponseModal.html',
                'mailchimp': 'mailChimpModal.html',
                'google': 'googleModal.html',
                'braintree': 'braintreeModal.html',
                'paypal': 'paypalModal.html',
                'paypal_express': 'paypalExpressModal.html',
                'stripe': 'stripeModal.html',
                'paystack': 'paystackModal.html',
                'payfast': 'payfastModal.html',
                'fondy': 'fondyModal.html',
                'cod': 'cod.html',
                'facebook': 'facebookModal.html',
                'facebookpixel': 'facebookPixelModal.html',
                'sendlane': 'sendlaneModal.html',
                'activecampaign': 'activeCampaignModal.html',
                'sendgrid': 'sendgridModal.html',
                'convertkit': 'convertKitModal.html',
                'mcafee': 'mcafeeModal.html',
                'xomator': 'xomatorModal.html',
                'scalable_press': 'scalablePressModal.html',
                'printful': 'printfulModal.html',
                'aftership': 'aftershipModal.html',
                'zapier': 'zapierModal.html',
            };

            if (!templateUrls[account.type]) {
                alert('Invalid account type: ' + account.type);
                return false;
            }

            var modal = wizardModal.open({
                'templateUrl': templateUrls[account.type],
                'controller': 'IntegrationsModalController',
                'size': 'md',
                'resolve': {
                    'account': function() {
                        return account;
                    },
                    'settings': function() {
                        return $scope.settings;
                    },
                    'paystackCurrencies': function() {
                        return $scope.paystackCurrencies;
                    }
                }
            });

            modal.result.then(function(account) {
                $scope.saveAccount(account);
            });
        };

        $scope.saveAccount = function(account, message, callback) {
            if (account.type == 'xomator') {
                return $scope.saveXomatorSettings(account);
            }

            $http.put(Routing.generate('integrations_update', {
                id: account.id
            }), account)
                .then(function(response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message);
                        return;
                    }

                    if (account.id == 0) {
                        $scope.accounts.push(response.data.account);
                    } else {
                        var found = false;

                        for (var i in $scope.accounts) {
                            if ($scope.accounts[i].id == account.id) {
                                $scope.accounts[i] = response.data.account;
                                found = true;
                                break;
                            }
                        }

                        if (!found) {
                            $scope.accounts.push(response.data.account);
                        }
                    }

                    $scope.$emit('integration.account.saved');

                    if (message) {
                        notifications.success(message);
                    } else {
                        notifications.success(response.data.message);
                    }
                    if (callback) {
                        callback();
                    }
                }, function() {
                    notifications.danger('Request error.');
                    if (callback) {
                        callback();
                    }
                }).finally($scope.closeModal)
            ;
        };

        $scope.openProConnectorRequiredModal = function () {
            wizardModal.open({
                'templateUrl': 'proConnectorRequiredModal.html',
                'size': 'md',
                'windowClass': 'modal-danger',
                'controller': function ($scope, $uibModalInstance) {
                    $scope.close = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                }
            });
        };

        $scope.toggleZapier = function ($event) {
            if ($scope.zapierRequest) {
                return;
            }
            $scope.zapierRequest = true;
            var account = $scope.getZapierDisactivatedAccount();

            function setZapierRequestFalse() {
                $scope.zapierRequest = false;
            }
            if (!account || account.name == 'inactive') {
                account = {
                    'id': account ? account.id : 0,
                    'name': 'active',
                    'type': 'zapier',
                    'properties': account ? account.properties : {},
                    'typeGroup': $scope.accountTypeGroup
                };
                $scope.saveAccount(account, 'Account has been enabled', setZapierRequestFalse());
                $scope.zapierEnabled = true;
            } else {
                account = {
                    'id': account.id,
                    'name': 'inactive',
                    'type': 'zapier',
                    'properties': account.properties,
                    'typeGroup': $scope.accountTypeGroup
                };
                $scope.saveAccount(account, 'Account has been disabled', setZapierRequestFalse());
                $scope.zapierEnabled = false;
            }
        };

        $scope.saveXomatorSettings = function(settings) {
            $http
                .post(
                    Routing.generate('xomator_update_settings'),
                    {
                        'settings': settings
                    }
                )
                .then(
                    function(response) {
                        if (!response.data.success) {
                            notifications.danger(response.data.message || 'Failed to save settings.');
                            return;
                        }

                        $scope.settings = settings;

                        notifications.success('Settings updated successfully.');
                    },
                    function() {
                        notifications.danger('Request error.');
                    }
                )
            ;
        };

        $scope.deleteAccount = function(account, callback) {
            $http.delete(Routing.generate('integrations_delete', {
                id: account.id
            }))
                .then(function(response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message);
                        return;
                    }

                    for (var i in $scope.accounts) {
                        if ($scope.accounts[i].id == account.id) {
                            $scope.accounts.splice(i, 1);
                            break;
                        }
                    }

                    notifications.success('Account has been deleted.');
                    if (callback) {
                        callback();
                    }
                }, function(response) {
                    notifications.danger('Request error.');
                    if (callback) {
                        callback();
                    }
                })
            ;
        };

        $scope.disconnectXomator = function() {
            $http
                .post(Routing.generate('xomator_disconnect'))
                .then(
                    function(response) {
                        if (!response.data.success) {
                            notifications.danger(response.data.message || 'Failed to remove xOmator integration.');
                            return;
                        }

                        $scope.settings.token = '';

                        notifications.success('Account has been deleted.');
                    },
                    function() {
                        notifications.danger('Request error.');
                    }
                )
            ;
        };

        $scope.searchTable = function(search) {
            if (!angular.equals({}, $scope.dtAccountsTableInstance) && $scope.dtAccountsTableInstance.hasOwnProperty('DataTable')) {
                $scope.dtAccountsTableInstance.DataTable.search(search);
                $scope.dtAccountsTableInstance.DataTable.draw();
            }
        };
    }]);
